import { Component, OnInit } from '@angular/core';
import { Router, NavigationCancel, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { TranslationService } from './shared/i18n/translation.service';
import { locale as enLang } from './shared/i18n/vocabs/en';
import { LoadingService } from './loading.service';
import { Title, Meta } from '@angular/platform-browser';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class AppComponent {
    isDarkTheme = true;

    toggleTheme(): void {
        this.isDarkTheme = !this.isDarkTheme;
        localStorage.setItem('theme', this.isDarkTheme ? 'dark' : 'light');
        this.applyTheme();
    }

    applyTheme(): void {
        if (this.isDarkTheme) {
            document.body.classList.add('dark-theme');
            document.body.classList.remove('light-theme');
        } else {
            document.body.classList.add('light-theme');
            document.body.classList.remove('dark-theme');
        }
    }

    showCokePopup = true;

    openCokePopup(): void {
        this.showCokePopup = true;
    }

    closeCokePopup(): void {
        this.showCokePopup = false;
    }
    location: any;
    routerSubscription: any;

    constructor(private router: Router,
        private translationService: TranslationService, private cookieService: CookieService,
        public loadingService: LoadingService, private titleService: Title, private metaService: Meta

    ) {
        this.translationService.loadTranslations(
            enLang,
        );

    }



    onConfirmCookies(): void {
        // Set cookie as visited
        this.cookieService.set('visited', 'true', 7);
        // Close popup
        this.showCokePopup = false;
    }


    ngOnInit() {
        this.titleService.setTitle('Staten Island Driving School - Learn to Drive');
        this.metaService.updateTag({ name: 'description', content: 'Join our certified driving school in Staten Island and get your license fast!' });

        const savedTheme = localStorage.getItem('theme');
        this.isDarkTheme = savedTheme ? savedTheme === 'dark' : true;
        this.applyTheme();

        this.recallJsFuntions();
        const hasVisited = this.cookieService.check('visited');

        if (!hasVisited) {
            this.showCokePopup = true;
        } else {
            this.showCokePopup = false;
        }
    }




    recallJsFuntions() {
        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
            .subscribe(event => {
                this.location = this.router.url;
                if (!(event instanceof NavigationEnd)) {
                    return;
                }
                window.scrollTo(0, 0);
            });
    }
}